module.exports = __webpack_public_path__ + "img/telsynergy.ae643b2f.png";